export default {
  nav: {
    home: "Home",
    about: "About",
    contact: "Contact"
  },
  languageSwitcher: {
    selectLanguage: "Select Language",
  },
  userMenu: {
    profile: "Profile",
    settings: "Settings",
    logout: "Logout"
  },
  home: {
    header: "Welcome to the Vue 3 I18n tutorial!",
    created_by: "This tutorial was brought to you by Lokalise.",
    welcome: "We are glad to have you here. Explore the internationalization features with Vue 3 and I18n."
  },
  about: {
    header: "About us"
  },
  login: {
    header: "Log in to your account",
    subheader: "Enter your credentials to access your account.",
    email: "Email Address",
    password: "Password",
    remember_me: "Remember Me",
    forgot_password: "Forgot your password?",
    login_button: "Log In",
    login_button_loading: "Logging In...",
    login_error: "Unable to log in. Please check your credentials and try again.",
    footer_sign_up_message: "Don't have an account?",
    footer_sign_up_link: "Sign Up now"
  },
  password_reset: {
    forgot_title: "Forgot your password?",
    forgot_description: "Enter your email address and we will send you a password reset link.",
    reset_title: "Reset your password",
    reset_description: "Choose a new password for your account.",
    confirm_password: "Confirm password",
    send_link: "Email password reset link",
    reset_button: "Reset password",
    processing: "Please wait...",
    back_to_login: "Back to login",
    link_sent: "We have emailed your password reset link. Please check your inbox.",
    reset_success: "Your password has been reset. You can now log in with your new password.",
    error: "Unable to complete your request. Please try again."
  },
  actions: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    update: "Update",
    ok: "OK"
  }
}
